import React, { createRef, useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { withRouter } from '../../../utils/withRouter';
import { bindActionCreators, Dispatch } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import classNames from 'classnames';
import { isEmpty } from 'lodash';

import * as actions from '../../../actions/index';
import ExpandableRow from '../../../components/ExpandableRow';
import MapContainer from '../../../components/MapContainer/index';
import './ResultsStep.scss';
import {
  prepareAddAllToBasketPayload,
  prepareAddToBasketPayload,
  prepareCreateBasketPayload,
} from '../../../utils/payloads';
import * as _actionsJourney3 from '../../../actions/journey3';
import * as _actionsJourney2 from '../../../actions/journey2';
import * as _actionsJourney1 from '../../../actions/journey1';
import * as _actionsBasket from '../../../actions/basket';
import * as _actionsFilters from '../../../actions/filters';
import ProductsTable from '../../../components/ProductsTable';
import { parseToApiDate, replaceUmlauts } from '../../../utils/react';
import { defined } from '../../../utils/variableEvaluation';
import { Button, EButtonType, Input, SwitchSize, KitIcons } from '@repo/apg-ui';
import { TypeContainer } from '../../../actions/typeContainer';
import { getPathname } from '../../../utils/paths';
import { ReactComponent as IconArrowRight } from '../../../assets/icons/black-arrow-right.svg';
import { ReactComponent as IconFilterOutline } from '../../../assets/icons/filter-outline.svg';
import { ReactComponent as CloseRedEye } from '../../../assets/icons/eye-close.svg';
import { ReactComponent as AddToBucket } from '../../../assets/icons/new/add_to_basket.svg';

import { geocodeByAddress } from 'react-places-autocomplete';
import { useMedia, usePrevious, useScroll, useUpdateEffect } from 'react-use';
import { useNavigate } from 'react-router';
import { ResultSorting } from '../../../components/ResultSorting';
import FastBookSearchInput from '../../../components/FastBookInput';
import { ListMapToggle } from '../../../components/ListMapToggle';
import {
  SchemaAvailableProductGroupAttributes,
  SchemaBasketdefinitionResponse,
  SchemaCoordinate,
  SchemaNewBasketResponse,
  SchemaPossibleBookingDates,
  SchemaProduct,
  SchemaProductGroupNode,
  SchemaSelectResponse,
} from '@repo/legacy-commerce-api';
import { PartiallyIntegratedUserDataEC } from '../../../reducers/app';

const placesAPIKey = process.env.REACT_APP_PLACES_API_KEY;

interface Props {
  actionsJourney1: typeof _actionsJourney1;
  actionsJourney2: typeof _actionsJourney2;
  actionsJourney3: typeof _actionsJourney3;
  actionsBasket: typeof _actionsBasket;
  actionsFilters: typeof _actionsFilters;
  availableAttributesJ2: SchemaAvailableProductGroupAttributes;
  containers: TypeContainer;
  history: any;
  intl: any;
  loading: { [key: string]: any };
  possibleBookingDates: SchemaPossibleBookingDates;
  postSelectResponseElements: SchemaProductGroupNode[] | null;
  productsJ2: SchemaProduct[];
  productsJ2ByUrn: Record<string, SchemaProduct>;
  productsNested: any;
  setStepLoading: (value: boolean) => void;
  urlHistory: string[];
  userDataEC: PartiallyIntegratedUserDataEC;
  router: any;
  generatePostPayload: any;
  isShowUnavailable: boolean;
  mapView: boolean;
  setMapView: any;
  currentSort: any;
  setCurrentSort: (value: any) => void;
  setIsShowUnavailable: (value: any) => void;
  sort: any;
  filterVisibility: boolean;
  setIsFilterOpen: (value: any) => void;
  setSort: (value: any) => void;
  getPostSelect: (mapPotentialCoordinates?) => void;
  slotsLoading: boolean;
  setSlotsLoading: (value: boolean) => void;
  products: SchemaProductGroupNode[];
}

const ResultsList = ({
  intl,
  products,
  userDataEC: { startDate, duration, locations, industry, shouldCreateNewBasketJ2, basketInfo, basketProducts },
  userDataEC,
  productsJ2,
  productsJ2ByUrn,
  actionsJourney2,
  actionsJourney3,
  actionsBasket,
  actionsFilters,
  router,
  containers,
  setStepLoading,
  loading,
  possibleBookingDates,
  availableAttributesJ2,
  generatePostPayload,
  isShowUnavailable,
  setIsShowUnavailable,
  currentSort,
  setCurrentSort,
  sort,
  setIsFilterOpen,
  filterVisibility,
  setSort,
  mapView,
  setMapView,
  getPostSelect,
  slotsLoading,
  setSlotsLoading,
}: Props) => {
  const [expandedRow, setExpandedRow] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const [tabJ2, setTabJ2] = React.useState(0);
  const [tabJ2Name, setTabJ2Name] = React.useState('');
  const [countTabsElements, setCountTabsElements] = React.useState({});
  const [criteriaLocations, setCriteriaLocations] = React.useState({});
  const [productTabsElements, setProductTabsElements] = React.useState({});
  const [productTabsAvailableAttributes, setProductTabsAvailableAttributes] = React.useState({});
  const [centerCordsMap, setCenterCordsMap] = React.useState({});
  const prevTabName = usePrevious(tabJ2Name);
  const [tabsScroll, setTabsScroll] = React.useState({
    scrollWidthParent: 0,
    scrollWidth: 0,
    scrollLeft: 0,
  });

  const tabsContainerRef = createRef<HTMLDivElement>();
  const dispatch = useDispatch();

  const prevIsShowUnavailable = usePrevious(isShowUnavailable);
  const prevBasketProducts = usePrevious(userDataEC.basketProducts.productsByUrn);
  const isMobile = useMedia('(max-width: 768px)');
  const isSMDevice = useMedia('(max-width: 576px)');

  const navigate = useNavigate();

  const openFastbookModalForMissingParameter = (producturn: string) => {
    navigate({ search: `?modalContent=fastbook&urn=${producturn}&missingparameter=1` });
  };

  const hasMissingParameter: boolean = !startDate || !industry;

  useUpdateEffect(() => {
    if (prevIsShowUnavailable !== isShowUnavailable) {
      getPostSelect();
    }

    // if ((prevProducts !== products && !!products) || (prevMapView !== mapView && !!products)) {
    //     getProductsAndCountsByTab();
    //     getCriteriaLocationsByTab();
    // }

    if (prevBasketProducts !== basketProducts.productsByUrn && !!basketProducts.productsByUrn) {
      changeBasketAvailableAttributes();
    }

    if (prevTabName !== tabJ2Name && tabJ2Name) {
      actionsJourney2.resetAttributes(productTabsAvailableAttributes[tabJ2Name]);
      getCenterCordsMap();
    }
  });

  useEffect(() => {
    getProductsAndCountsByTab();
    getCriteriaLocationsByTab();
  }, [products]);

  // componentWillUnmount() {
  //     this.props.setStepLoading(false);
  //     this.props.handleMapView(false);
  //
  //     const ref = this.tabsContainerRef.current;
  //     ref.removeEventListener('scroll', () => this.handleScroll(ref.scrollLeft));
  //     window.removeEventListener('gApiLoaded', this.preloadLocationData);
  // }

  useEffect(() => {
    const ref = tabsContainerRef.current;
    ref.addEventListener('scroll', () => handleScroll(ref.scrollLeft));

    const payload = generatePostPayload();
    (window as any).gApiLoaded = new Event('gApiLoaded');
    (window as any).addEventListener('gApiLoaded', preloadLocationData);

    const query = new URLSearchParams(router.location.search) as any;
    const shouldCreateBasket = (query.basketId && query.basketreference) || shouldCreateNewBasketJ2;

    if (shouldCreateBasket || containers.isJourney3) {
      if (Object.keys(locations).length > 0 || (query.basketId && query.basketreference)) {
        setSlotsLoading(true);

        if (query.basketId && query.basketreference) {
          const copiedBasketInfo = {
            basket: query.basketId,
            basketreference: query.basketreference,
          };
          actionsJourney2.setBasketInfo(copiedBasketInfo);

          // We need to preload google API to set locations (and use geocodeByAddress)
          const script = document.createElement('script');
          script.src = `https://maps.googleapis.com/maps/api/js?key=${placesAPIKey}&libraries=places`;
          script.id = 'gapi';
          script.async = true;
          script.onload = () => preloadLocationData();
          document.getElementById('gapi') === null && document.body.appendChild(script);

          actionsBasket
            .getBasketContent(copiedBasketInfo)
            .then(() => {
              actionsJourney3
                .getUserData({
                  basket: query.basketId,
                  basketreference: query.basketreference,
                })
                .then((res: SchemaBasketdefinitionResponse) => {
                  res.data.availability &&
                    actionsFilters.updateStartDate([
                      parseToApiDate(res.data.availability.startdate),
                      res.data.availability.duration,
                    ]);

                  res &&
                    res.data.coordinate.forEach((loc: SchemaCoordinate) => {
                      geocodeByAddress(loc.name)
                        .then((results) => {
                          actionsJourney3.updateLocation({
                            name: loc.name,
                            data: results[0],
                          });

                          getPostSelect();
                        })
                        .catch((error) => console.error('Error', error));
                    });
                });
              setStepLoading && setStepLoading(true);
            })
            .catch((err: any) => console.error(err));
        } else {
          actionsJourney2.postSelect(payload).then((res: SchemaSelectResponse) => {
            setTabJ2(0);
            setTabJ2Name(
              res?.data?.elements &&
                res?.data?.elements[0]?.subgroup &&
                res.data.elements[0].subgroup.elements[0].groupvalue,
            );
            getCenterCordsMap();

            setStepLoading && setStepLoading(true);

            if (res && res.data && res.data.count > 0) {
              if (basketInfo && basketInfo.basket) {
                // @ts-expect-error properties of "state" don't match number vs union type:
                actionsBasket.getBasketContent(basketInfo).catch((err: any) => console.error(err));
              }
            }
            setSlotsLoading(false);
          });
        }
      } else {
        navigate(getPathname(containers)(1));
      }
    } else if (products[0]) {
      setTabJ2(0);
      setTabJ2Name(products[0] && products[0].subgroup.elements[0].groupvalue);
      getCenterCordsMap();
      setStepLoading && setStepLoading(true);
      setSlotsLoading(false);
    }
  }, []);

  const handleScroll = (_scrollLeft: number) => {
    setTabsScroll((prevState) => {
      return {
        scrollWidthParent: prevState.scrollWidthParent,
        scrollWidth: prevState.scrollWidth,
        scrollLeft: _scrollLeft,
      };
    });
  };

  const preloadLocationData = () => {
    const query = new URLSearchParams(router.location.search) as any;
    actionsJourney3
      .getUserData({
        basket: query.basketId,
        basketreference: query.basketreference,
      })
      .then((res: SchemaBasketdefinitionResponse) => {
        res &&
          res.data &&
          (res.data.coordinate || []).forEach((loc: SchemaCoordinate) => {
            geocodeByAddress(loc.name)
              .then((results) => {
                actionsJourney3.updateLocation({
                  name: loc.name,
                  data: results[0],
                });
              })
              .catch((error) => console.error('Error', error));
          });
      });
  };

  const createBasket = (addProduct: boolean, product: any, newProductData?: any, isSelectAll?: boolean) => {
    const basket_payload = prepareCreateBasketPayload(
      '',
      industry,
      startDate || product?.startdate || newProductData?.startDate || null,
    );

    if (isSelectAll) {
      setIsLoading(true);
    }
    return actionsBasket
      .createBasket(basket_payload)
      .then((res: SchemaNewBasketResponse) => {
        if (res) {
          return res.data;
        }

        setIsLoading(false);
        throw new Error('J2. Step6. Cannot create a basket');
      })
      .then((basketData: SchemaNewBasketResponse) => {
        if (isSelectAll) {
          addAllProductToBasket(basketData);
        } else if (basketData && addProduct && product) {
          addToBasket(product, newProductData, basketData);
        }
      })
      .catch((err: any) => console.error(err));
  };

  const addToBasket = (product: SchemaProduct, newProductData?, newBasketInfo?) => {
    const producturn = product.producturn;
    // @ts-expect-error does not exist on SchemaProduct
    const productDuration = product.duration;
    const finalBasketInfo = basketInfo || newBasketInfo;

    if (finalBasketInfo) {
      const { basket, basketreference } = finalBasketInfo;
      let startdate = newProductData?.startDate || startDate || product.startdate || null;
      const payload = prepareAddToBasketPayload(
        basket,
        basketreference,
        startdate,
        newProductData?.duration || productDuration || duration,
        producturn,
        industry,
        product.defaulttimeslot,
      );

      return actionsBasket
        .addToBasket(payload)
        .then(() => {
          actionsBasket
            .getBasketContent(finalBasketInfo)
            .then(() => {
              setProductTabsElements({
                ...productTabsElements,
                basket: basketProducts.productsByUrnDate,
              });
            })
            .catch((err: any) => console.error(err));
        })
        .catch((err: any) => console.error(err));
    } else {
      return createBasket(true, product, newProductData);
    }
  };

  const addAllProductToBasket = (newBasketInfo?) => {
    const producturns = Object.keys(productTabsElements[tabJ2Name]);
    const filteredProductURNs = producturns?.filter((urn) => !basketProducts?.productsByUrn[urn]);
    const finalBasketInfo = basketInfo || newBasketInfo;
    const firstProduct = productTabsElements[tabJ2Name][producturns[0]] || null;

    if (finalBasketInfo) {
      const { basket, basketreference } = finalBasketInfo;

      const payload = prepareAddAllToBasketPayload(
        basket,
        basketreference,
        firstProduct?.startdate || finalBasketInfo?.startDate || startDate || null,
        firstProduct?.duration || finalBasketInfo?.duration || duration,
        filteredProductURNs,
        industry,
      );
      setIsLoading(true);
      return actionsBasket
        .addToBasket(payload)
        .then(() => {
          setIsLoading(true);
          actionsBasket
            .getBasketContent(finalBasketInfo)
            .then(() => {
              setProductTabsElements({
                ...productTabsElements,
                basket: basketProducts.productsByUrnDate,
              });
            })
            .catch((err: any) => console.error(err));
        })
        .catch((err: any) => console.error(err))
        .finally(() => setIsLoading(false));
    } else {
      return createBasket(true, undefined, undefined, true);
    }
  };

  const handleProductSelectDeselect = (product: SchemaProduct, value, newProductData?) => {
    const { producturn, basketkey } = product;
    if (value) {
      let startdate = newProductData?.startDate || startDate || product.startdate || null;
      if (shouldCreateNewBasketJ2) {
        const basket_payload = prepareCreateBasketPayload(
          '',
          industry,
          startDate || product?.startdate || newProductData?.startDate || null,
        );

        return actionsBasket
          .createBasket(basket_payload)
          .then((res: SchemaNewBasketResponse) => {
            if (res) {
              if (hasMissingParameter) {
                openFastbookModalForMissingParameter(producturn);
                return Promise.reject(new Error('No Startdate or Industry, have to use Fastbook'));
              } else {
                return addToBasket(product, newProductData);
              }
            } else {
              return Promise.reject(null);
            }
          })
          .catch((err: any) => console.error(err));
      } else {
        if (hasMissingParameter) {
          openFastbookModalForMissingParameter(producturn);
          return Promise.reject(new Error('No Startdate or Industry, have to use Fastbook'));
        } else {
          return addToBasket(product, newProductData);
        }
      }
    } else if (basketkey && basketProducts.productsByUrnDate[basketkey]) {
      const basketEntry =
        basketProducts.productsByUrnDate[basketkey]['basketentryid'] ||
        basketProducts.productsByUrnDate[basketkey]['entryid'];
      if (basketEntry) {
        const payload = {
          entries: [basketEntry],
          basketreference: basketInfo.basketreference,
          basket: basketInfo.basket,
        };

        return actionsBasket
          .removeFromBasketByPayload(payload, producturn)
          .then(() => {
            // @ts-expect-error properties of "state" don't match number vs union type:
            actionsBasket.getBasketContent(basketInfo);
          })
          .catch((err: any) => console.error(err));
      }
    } else {
      console.log('No basketkey ' + basketkey);
    }
  };

  const updateDateAndDuration = (startDate: string, duration: number, producturn: string) => {
    const payload = {
      startdate: parseToApiDate(startDate),
      duration: duration,
      producturn: producturn,
    };
    actionsJourney2.updateDateAndDuration(payload);
  };

  const changeProductDate = (basketEntry: number, startDate: string, duration: number) => {
    return actionsJourney2
      .changeProductDate({
        basketentry: basketEntry,
        basketreference: basketInfo.basketreference,
        startdate: parseToApiDate(startDate),
        duration: duration,
      })
      .then(() => {
        if (basketInfo && basketInfo.basket) {
          // @ts-expect-error properties of "state" don't match number vs union type:
          actionsBasket.getBasketContent(basketInfo).catch((err: any) => console.error(err));
        }
      })
      .catch((err: any) => console.error(err));
  };

  const getAvailabilityForDigitalProduct = (producturn: string, startDate: string, duration: number) => {
    const payload = {
      producturn: producturn,
      startdate: parseToApiDate(startDate),
      duration: duration,
    };
    actionsJourney2.getAvailabilityForDigitalProduct(payload);
  };

  const getProductPrice = (producturn: string, startDate: string) => {
    const payload = {
      producturn: producturn,
      startdate: startDate ? parseToApiDate(startDate) : '',
    };
    actionsJourney2.getPriceForProduct(payload);
  };

  const formatRadius = (product) => {
    let radius;

    if (defined(locations[replaceUmlauts(product.groupvalue)]?.circle?.radius)) {
      radius = locations[replaceUmlauts(product.groupvalue)]?.circle.radius;
    }

    if (!!radius) {
      const a = radius / 1000;

      if (Math.floor(a) == 0) {
        return radius.toFixed(0) + ' m';
      }

      return Number(a.toFixed(1)) + ' km';
    }

    return null;
  };

  const isTabSelected = (tab: number) => tab === tabJ2;

  const renderTabContent = () => {
    return (
      <div
        className={classNames('w-100 p-0', {
          'semi-transparent': slotsLoading,
        })}
      >
        {!!productsJ2 &&
          products.map(({ subgroup, groupvalue }, index) => {
            let groupTitle: string;
            let countElements: string = '';
            let elements: SchemaProductGroupNode[] = [];

            !!subgroup.elements &&
              subgroup.elements.forEach(({ groupvalue, count, subgroup }: any) => {
                if (groupvalue === tabJ2Name) {
                  countElements = count;
                  elements = subgroup.elements;
                }
              });

            if (!countElements || !elements) {
              return null;
            }

            if (groupvalue === 'digital') {
              groupTitle = intl.formatMessage({
                id: 'ec.components.journey02.map.digitalProducts',
                defaultMessage: 'Digital',
              });
            } else if (groupvalue === 'analog') {
              groupTitle = intl.formatMessage({
                id: 'ec.components.journey02.map.analogProducts',
                defaultMessage: 'Plakate',
              });
            } else {
              groupTitle = intl.formatMessage({
                id: 'ec.components.journey02.map.trafficProducts',
                defaultMessage: 'ÖV-Innenformate',
              });
            }

            const moreContent = (
              <ProductsTable
                basketEntries={basketProducts.productsByUrnDate}
                changeProductDate={changeProductDate}
                currentSort={currentSort}
                getAvailabilityForDigitalProduct={getAvailabilityForDigitalProduct}
                getProductPrice={getProductPrice}
                journey2
                loading={loading}
                onChange={() => null}
                possibleBookingDates={possibleBookingDates}
                productsNested={elements}
                updateDateAndDuration={updateDateAndDuration}
                userDataEC={userDataEC}
                productsJ2ByUrn={productsJ2ByUrn}
                sort={sort}
                sortChanged={(sortName) => {
                  setSort({ ...sort, [sortName]: sort[sortName] ? 0 : 1 });
                  setCurrentSort(sortName);
                  getPostSelect();
                }}
                handleProductSelectClick={(product, value, newProductData?) =>
                  handleProductSelectDeselect(product, value, newProductData)
                }
                tabJ2={tabJ2}
                isDigiflex={groupvalue === 'digital'}
              />
            );

            if (isIndividualProducts(tabJ2Name)) {
              return moreContent;
            }

            return (
              <ExpandableRow
                className='result-list-expandable'
                expandable
                expanded={expandedRow}
                index={index}
                title={`${groupTitle} (${countElements})`}
                key={`expandable_row_${index}`}
                rowChanged={(val) => {
                  setExpandedRow(val);
                }}
                moreContent={moreContent}
              />
            );
          })}
      </div>
    );
    // }
  };

  const getProductsAndCountsByTab = () => {
    setSlotsLoading(true);
    let _countTabsElements: Record<string, any> = {};
    let _productTabsElements: Record<string, any> = {};
    let _productTabsAvailableAttributes = { basket: {} };

    if (products && products.length > 0) {
      products.forEach((element) => {
        const elements = element.subgroup.elements;

        !!elements &&
          elements.length > 0 &&
          elements.forEach(({ groupvalue, subgroup, count }: any) => {
            _countTabsElements[groupvalue] = (_countTabsElements[groupvalue] || 0) + count;
            _productTabsElements[groupvalue] = subgroup.elements
              .map((el) => el.products)
              .flat()
              .reduce(
                (acc, el) => {
                  const { format, producttype, attributeshortcuts } = el;

                  let posterAttribute = 'Normalplakat';

                  if (attributeshortcuts === 'L') {
                    posterAttribute = 'Leuchtend (L)';
                  } else if (attributeshortcuts === 'LR') {
                    posterAttribute = 'Leuchtend / Rotierend (LR)';
                  }

                  if (el.producturn) {
                    acc[el.producturn] = el;

                    if (!_productTabsAvailableAttributes[groupvalue]) {
                      _productTabsAvailableAttributes[groupvalue] = {};
                    }

                    if (!_productTabsAvailableAttributes[groupvalue][producttype]) {
                      _productTabsAvailableAttributes[groupvalue][producttype] = {};
                    }

                    if (!_productTabsAvailableAttributes[groupvalue]['surface']) {
                      _productTabsAvailableAttributes[groupvalue]['surface'] = {};
                    }

                    _productTabsAvailableAttributes[groupvalue][producttype][format] = true;

                    _productTabsAvailableAttributes[groupvalue]['surface'][posterAttribute] = true;
                  }

                  return acc;
                },
                { ..._productTabsElements[groupvalue] },
              );
          });
      });
    }

    _productTabsElements['basket'] = basketProducts.productsByUrnDate;
    const ref = tabsContainerRef.current;
    _productTabsAvailableAttributes.basket = getBasketAvailableAttributes(basketProducts.productsByUrn);

    actionsJourney2.resetAttributes(_productTabsAvailableAttributes[tabJ2Name]);

    setCountTabsElements(_countTabsElements);
    setProductTabsElements(_productTabsElements);
    setProductTabsAvailableAttributes(_productTabsAvailableAttributes);
    setTabsScroll({
      scrollWidthParent: ref.offsetParent?.scrollWidth,
      scrollWidth: ref.scrollWidth,
      scrollLeft: ref.scrollLeft,
    });
    getCenterCordsMap();
    setSlotsLoading(false);
  };

  const getBasketAvailableAttributes = (products: object): object => {
    let basketAvailableAttributes = {};

    if (!isEmpty(products)) {
      Object.values(products).forEach(({ format, producttype }: any) => {
        if (!basketAvailableAttributes[producttype]) {
          basketAvailableAttributes[producttype] = {};
        }

        basketAvailableAttributes[producttype][format] = true;
      });
    }

    return basketAvailableAttributes;
  };

  const changeBasketAvailableAttributes = () => {
    setProductTabsAvailableAttributes({
      ...productTabsAvailableAttributes,
      basket: getBasketAvailableAttributes(basketProducts.productsByUrn),
    });
  };

  const getCenterCordsMap = () => {
    const products = !!productTabsElements && tabJ2Name ? productTabsElements[tabJ2Name] : {};
    const firstProduct = (!!products ? Object.values(products)[0] : {}) as any;
    let centerCordsMap = {};
    let city = !!firstProduct ? firstProduct.city : null;

    if (firstProduct && firstProduct.latitude && firstProduct.longitude) {
      centerCordsMap = {
        lat: firstProduct.latitude,
        lng: firstProduct.longitude,
      };
    } else if (locations && locations[tabJ2Name]) {
      centerCordsMap = locations[tabJ2Name].lngLtd;
    } else if (locations) {
      const locationsNew = Object.values(locations).reduce((acc, item: any) => {
        acc[item.address] = item;

        return acc;
      }, {});

      if (locationsNew && (locationsNew[tabJ2Name] || locationsNew[city])) {
        centerCordsMap = locationsNew[tabJ2Name] ? locationsNew[tabJ2Name].lngLtd : locationsNew[city].lngLtd;
      }
    }

    setCenterCordsMap(centerCordsMap);
  };

  const isIndividualProducts = (value: string) => value === 'individualproducts';

  const handleClickArrow = (side: string) => {
    const ref = tabsContainerRef.current;

    if (ref) {
      const scrollLeft = ref.scrollLeft;
      const left = side === 'right' ? scrollLeft + 100 : scrollLeft - 100;

      handleScroll(left);
      ref.scrollTo({ top: 0, left, behavior: 'smooth' });
    }
  };

  const getCriteriaLocationsByTab = () => {
    const locationsValues = Object.values(locations);
    let criteriaLocations = {};

    if (!isEmpty(locationsValues)) {
      locationsValues.forEach((location: any) => (criteriaLocations[location.address] = location));
      setCriteriaLocations(criteriaLocations);
    }
  };

  const rootScrollRef = React.useRef(document.getElementById('root'));
  const viewToggleFilterRef = React.useRef<HTMLDivElement>();
  const scrollPos = useScroll(rootScrollRef);
  const [isSticky, setIsSticky] = useState<boolean>(false);

  const handleOnScroll = () => {
    // We need this to make it work in the CMS-integrated version of the app because another solution doesn't work

    const position = window.scrollY;
    if (viewToggleFilterRef.current) {
      const elementRef = viewToggleFilterRef.current.getBoundingClientRect();
      if (elementRef && position >= 296 - elementRef.height) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    }
  };

  const HandleAddAllProductsIntoBasket = () => {
    if (
      tabJ2Name &&
      productTabsElements &&
      productTabsElements[tabJ2Name] &&
      Object.keys(productTabsElements[tabJ2Name]).length
    ) {
      if (shouldCreateNewBasketJ2) {
        createBasket(true, undefined, undefined, true);
      } else {
        return addAllProductToBasket();
      }
    }
  };

  const showAddToBasketButton = () => {
    if (
      products &&
      products[0]?.subgroup?.elements.length <= 4 &&
      tabJ2Name &&
      productTabsElements &&
      productTabsElements[tabJ2Name]
    ) {
      const activeTabProductCount = Object.keys(productTabsElements[tabJ2Name]).length;
      const filteredProductURNs: string[] = Object.keys(productTabsElements[tabJ2Name])?.filter(
        (urn) => !basketProducts?.productsByUrn[urn],
      );

      if (activeTabProductCount > 0 && activeTabProductCount <= 50 && userDataEC.startDate && userDataEC.industry) {
        return (
          <div className='d-block ms-3 select-all-button'>
            <Button
              buttonType={EButtonType.PillMedium}
              isLoading={isLoading}
              isDisabled={isLoading || !filteredProductURNs.length}
              className={classNames('mt-0 px-4 w-100 fw-bold')}
              onClick={() => HandleAddAllProductsIntoBasket()}
            >
              <div className='d-flex justify-content-center align-items-center h-100'>
                <span className='me-2'>
                  <FormattedMessage id='ec.components.buttons.selectAll' defaultMessage='Select all' />
                </span>
                <AddToBucket />
              </div>
            </Button>
          </div>
        );
      }
    }

    return null;
  };

  useEffect(() => {
    window.addEventListener('scroll', handleOnScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleOnScroll);
    };
  }, []);

  useEffect(() => {
    if (viewToggleFilterRef.current) {
      const elementRef = viewToggleFilterRef.current.getBoundingClientRect();
      if (elementRef && rootScrollRef.current.scrollTop >= 296 - elementRef.height) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    }
  }, [scrollPos.y]);

  return (
    <div className={classNames('step6 nonBasketTab')}>
      {isMobile && (
        <>
          {isSticky && <div className='fix-spacing' />}
          <div
            ref={viewToggleFilterRef}
            className={classNames('w-100 bg-white p-4 mb-4', {
              isSticky: isSticky,
            })}
          >
            <div className='d-flex align-items-center justify-content-between gap-3'>
              {isSMDevice && <ListMapToggle setMapView={setMapView} mapView={mapView} />}

              {!isSMDevice && isMobile && (
                <div className='fastbook-input-wrapper d-block'>
                  <FastBookSearchInput />
                </div>
              )}

              <div className={classNames('d-flex left-action-buttons align-items-center flex-wrap')}>
                <div className='filter-toggle d-flex flex-row' onClick={() => setIsFilterOpen(true)}>
                  <FormattedMessage id='ec.components.filter.seeFilters' defaultMessage='See Filters' />
                  <span className='filter-icon ms-2'>
                    <IconFilterOutline />
                  </span>
                </div>

                {isSMDevice && (
                  <ResultSorting
                    sort={sort}
                    loading={slotsLoading}
                    currentSort={currentSort}
                    sortChanged={(sortName, sortOrder) => {
                      setSort({ ...sort, [sortName]: sortOrder });
                      setCurrentSort(sortName);
                      getPostSelect();
                    }}
                  />
                )}
              </div>
            </div>

            <div className='d-flex align-items-center justify-content-end gap-3 mt-2'>
              {isSMDevice && showAddToBasketButton()}
            </div>
          </div>
        </>
      )}

      {!isSMDevice && (
        <div className='w-100 pt-3 pt-lg-0'>
          <ResultSorting
            sort={sort}
            loading={slotsLoading}
            currentSort={currentSort}
            sortChanged={(sortName, sortOrder) => {
              setSort({ ...sort, [sortName]: sortOrder });
              setCurrentSort(sortName);
              getPostSelect();
            }}
          />
        </div>
      )}
      <div
        className={classNames('w-100 d-flex align-items-start', {
          'semi-transparent': slotsLoading,
        })}
      >
        {!filterVisibility && !isMobile && (
          <div className='d-flex align-items-center justify-content-start flex-row me-48'>
            <span className='fw-bold font-24 mb-1'>Filters</span>
            <div
              className='cursor-pointer px-3'
              onClick={() => {
                actionsFilters.setResultsFiltersVisibility(true);
              }}
            >
              <CloseRedEye />
            </div>
          </div>
        )}
        <div className='bg-grey w-100'>
          <div className='d-flex align-items-center'>
            <div className='d-flex product-tabs-block justify-content-between align-items-center'>
              {tabsScroll.scrollWidth > 0 &&
                tabsScroll.scrollWidthParent < tabsScroll.scrollWidth &&
                tabsScroll.scrollLeft > 50 && (
                  <span className={'product-tabs-block__arrow-left'} onClick={() => handleClickArrow('left')}>
                    <IconArrowRight />
                  </span>
                )}

              <div
                className={classNames('d-flex flex-nowrap product-tabs-block__scroll-tabs h-100', {
                  'semi-transparent': slotsLoading,
                })}
                ref={tabsContainerRef}
              >
                {products &&
                  products[0] &&
                  products[0].subgroup.elements.map((product: SchemaProductGroupNode, idx: number) => {
                    return (
                      <div
                        key={`product-table-key-${idx}`}
                        className={classNames('products-table-tab-post pe-4', {
                          selected: isTabSelected(idx),
                        })}
                        onClick={() => {
                          setTabJ2(idx);
                          setTabJ2Name(product.groupvalue);
                        }}
                      >
                        <div className='d-flex align-items-center mb-2 '>
                          <div className='icon-flaschen'>{KitIcons.searchGroups[product.context]}</div>

                          <span className='city-flaschen fw-bold ms-3'>
                            {isIndividualProducts(product.groupvalue) ? (
                              <FormattedMessage id='ec.journey02.step06.individualProducts' defaultMessage='Produkte' />
                            ) : (
                              product.groupvalue
                            )}

                            {defined(formatRadius(product)) ? (
                              <>
                                &nbsp;({formatRadius(product)}
                                <FormattedMessage id='ec.journey02.step06.radius' defaultMessage=' Radius' />)
                              </>
                            ) : null}
                          </span>
                        </div>

                        <p className='mini-city-flaschen text-grey-light mb-4'>
                          {countTabsElements[product.groupvalue]}{' '}
                          <FormattedMessage id='ec.journey02.step06.flachen' defaultMessage='Flächen' />
                        </p>
                      </div>
                    );
                  })}
              </div>

              {tabsScroll.scrollWidth > 0 &&
                tabsScroll.scrollWidthParent + tabsScroll.scrollLeft - 50 < tabsScroll.scrollWidth && (
                  <span className={'product-tabs-block__arrow-right'} onClick={() => handleClickArrow('right')}>
                    <IconArrowRight />
                  </span>
                )}
            </div>

            {!isSMDevice && showAddToBasketButton()}

            {!isSMDevice && <ListMapToggle setMapView={setMapView} mapView={mapView} />}
          </div>
        </div>
      </div>

      {!slotsLoading && products && products.length === 0 && (
        <FormattedMessage id='ec.components.notice.noResultsFound' defaultMessage='Keine Resultate gefunden' />
      )}

      {mapView && productTabsElements[tabJ2Name] ? (
        <div className='mapContainer'>
          {centerCordsMap && (
            <MapContainer
              center={centerCordsMap}
              zoom={15}
              handleProductSelectClick={(product, value) => handleProductSelectDeselect(product, value)}
              availableAttributes={availableAttributesJ2}
              intl={intl}
              overviewJ2
              dispatch={dispatch}
              basketEntries={basketProducts.productsByUrnAll}
              actionsJourney2={actionsJourney2}
              locations={productTabsElements[tabJ2Name]}
              productUrnStrBasket={Object.keys(basketProducts.productsByUrn || []).join('-')}
              useCustomMarker
              criteriaLocations={{
                [tabJ2Name]: criteriaLocations[tabJ2Name],
              }}
              loading={loading['general']}
              updateProducts={(mapPotentialCoordinates) => getPostSelect(mapPotentialCoordinates)}
            />
          )}
          <div className='d-flex justify-content-start pt-24 map-legends'>
            <div className='me-4 d-flex justify-content-center align-items-center'>
              <span className='map-legend available' />
              <span>
                <FormattedMessage id='ec.journey02.step06.available' defaultMessage='Verfügbar' />
              </span>
            </div>
            <div className='me-4 d-flex justify-content-center align-items-center'>
              <span className='map-legend unavailable' />
              <span className='text'>
                <FormattedMessage id='ec.journey02.step06.unavailable' defaultMessage='Nicht verfügbar' />
              </span>
            </div>
            <div className='me-4 d-flex justify-content-center align-items-center'>
              <span className='map-legend in-shopping-cart' />
              <span className='text'>
                <FormattedMessage id='ec.journey02.step06.inShoppingCart' defaultMessage='Im Warenkorb' />
              </span>
            </div>
          </div>
        </div>
      ) : (
        renderTabContent()
      )}

      <>
        <div className='switch-wrapper d-flex align-items-center'>
          <Input
            name={'availabilityProducts'}
            type='switch'
            size={SwitchSize.LARGE}
            inputWrapperClass={'me-4'}
            defaultChecked={isShowUnavailable}
            value={isShowUnavailable}
            onChange={(name, value) => setIsShowUnavailable(value)}
          />

          <FormattedMessage id='ec.components.switchText' defaultMessage='Nicht verfügbare Flächen anzeigen' />
        </div>
      </>
    </div>
  );
};

function mapStateToProps(state: any, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
    locales: state.locales,
    router: state.router,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
  return {
    actionsJourney1: bindActionCreators(_actionsJourney1 as any, dispatch),
    actionsJourney2: bindActionCreators(_actionsJourney2 as any, dispatch),
    actionsJourney3: bindActionCreators(_actionsJourney3 as any, dispatch),
    actionsBasket: bindActionCreators(_actionsBasket as any, dispatch),
    actionsFilters: bindActionCreators(_actionsFilters as any, dispatch),
    dispatch: dispatch,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(ResultsList)));
